<div class="form-group error red" [class.red]="isError" [class.green]="!isError" *ngIf="validationErrors?.length > 0">
  <h3 *ngFor="let error of validationErrors">{{ error }}</h3>
</div>
